import request from '@/utils/request'

// 获取统计数据
export function getStatistics() {
  return request({
    url: '/sys/statistic',
    method: 'get'
  })
}

// 获取仪表盘统计数据（mock）
export function getDashboardStats() {
  return Promise.resolve({
    balance: 15000.00,
    todayConsume: 1280.50,
    monthConsume: 8750.30,
    totalConsume: 45680.90
  })
}

// 获取用户统计数据（mock）
export function getUserStats() {
  return Promise.resolve({
    todayActiveUsers: 156,
    monthActiveUsers: 2890,
    todayNewUsers: 23,
    monthNewUsers: 345,
    totalUsers: 5678
  })
}

// 获取IP统计数据（mock）
export function getIpStats() {
  return Promise.resolve({
    totalIps: 10000,
    activeIps: 7500,
    usageRate: 75
  })
}

// 获取趋势数据（mock）
export function getTrendStats(params) {
  const days = parseInt(params?.days || 7)
  const now = new Date()
  const data = { consume: [], ipUsage: [], userGrowth: [] }
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date()
    date.setDate(now.getDate() - i)
    const dateStr = date.toISOString().split('T')[0]
    data.consume.push({ date: dateStr, value: Math.floor(Math.random() * 2000 + 500) })
    data.ipUsage.push({ date: dateStr, value: Math.floor(Math.random() * 2000 + 6000) })
    data.userGrowth.push({ date: dateStr, value: Math.floor(Math.random() * 40 + 10) })
  }
  return Promise.resolve(data)
}

// 获取告警信息（mock）
export function getAlerts() {
  return Promise.resolve([
    {
      id: 1,
      type: 'warning',
      title: '账户余额警告',
      message: '您的账户余额低于 20000 元，请及时充值',
      time: '2025-05-24 10:30:00'
    },
    {
      id: 2,
      type: 'info',
      title: 'IP 使用率提醒',
      message: 'IP 使用率达到 75%，建议增加 IP 库存',
      time: '2025-05-24 09:15:00'
    },
    {
      id: 3,
      type: 'success',
      title: '新用户增长',
      message: '今日新增用户 23 个，环比增长 15%',
      time: '2025-05-24 08:00:00'
    }
  ])
}
